<share-buttons [theme]="'circles-dark'" [include]="['copy','facebook','twitter','linkedin','messenger','whatsapp']"
    [show]="11" [url]="url"></share-buttons>